import _ from 'underscore';
import { ProjectionGridBaseColumn } from '@bingads-webui/projection-grid-base-column';
import { getFieldValueFromGridData } from '@bingads-webui-campaign/recommendation-core';

export class CampaignPriorityColumn extends ProjectionGridBaseColumn {
  constructor({ i18n, newI18n }) {
    const title = newI18n.getString(_TL_('Campaign priority'));
    super({
      name: 'CampaignPriority',
      property: 'Opportunities/CampaignPriority',
      title,
      bodyClasses: ['grid-column-campaignPriority'],
      colClasses: ['col-shortText'],
      sortable: false,
      type: 'string',
      helpAriaLabel: i18n.getString('Click to learn more about {{item}}', { item: title }),
    });
    this.i18n = i18n;
  }

  template({
    value: {
      GridData,
    },
  }) {
    return getFieldValueFromGridData(GridData, 'Priority');
  }

  get property() {
    return {
      get: item => _.first(item.Opportunities),
    };
  }
}
